export const OuterLayoutLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="763"
    height="975"
    viewBox="0 0 763 975"
    fill="none"
  >
    <path
      opacity="0.05"
      d="M503.294 267.688L389.437 381.814C322.016 449.394 212.668 449.397 144.678 381.814H144.679L0.705078 237.502L236.942 0.708008L503.294 267.688Z"
      fill="white"
      stroke="white"
    />
    <path
      opacity="0.05"
      d="M762.292 525.939L313.809 974.293L204.006 864.521C133.999 794.534 133.996 680.73 204.006 610.17L204.007 610.171L524.991 288.707L762.292 525.939Z"
      fill="white"
      stroke="white"
    />
  </svg>
);
